import { render, staticRenderFns } from "./error-500.vue?vue&type=template&id=05cc4390&"
import script from "./error-500.vue?vue&type=script&lang=ts&"
export * from "./error-500.vue?vue&type=script&lang=ts&"
import style0 from "./error-500.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports